import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Spinner, Container, Row, Col } from 'react-bootstrap';
import BaseLayout from '../../admin/BaseLayout';
import { API_BASE_URL } from '../../config/api';

const Blog = () => {
    const [selectedPost, setSelectedPost] = useState(null);
    const [archive, setArchive] = useState([]);
    const [loading, setLoading] = useState(true);
    const { id } = useParams();
    const navigate = useNavigate();

    const fetchArchive = async () => {
        try {
            // 1. Get List of All Posts
            const res = await axios.get(`${API_BASE_URL}/api/blog/all`);
            const posts = res.data;
            setArchive(posts);

            if (!id && posts.length > 0) {
                // Select the most recent one
                fetchPostContent(posts[0].id);
            } else {
                setLoading(false);
            }

        } catch (err) {
            setLoading(false);
        }
    };

    const fetchPostContent = (id) => {
        setLoading(true);
        axios.get(`${API_BASE_URL}/api/blog/post/${id}`)
            .then(res => {
                // Process content to highlight percentages in Purple
                const processedContent = res.data.content.replace(
                    /(\d+(?:[\.,]\d+)?%)/g,
                    '<span class="text-neon-purple glow-purple">$1</span>'
                );
                setSelectedPost({ ...res.data, content: processedContent });
                setLoading(false);
            })
            .catch(err => setLoading(false));
    };

    useEffect(() => {
        fetchArchive();
    }, []);

    useEffect(() => {
        if (id) {
            fetchPostContent(id);
        }
    }, [id]);

    return (
        <BaseLayout>
            <Container fluid className="px-0 py-4 px-md-5">
                <Row className="gx-5">
                    {/* MAIN CONTENT (70%) - READER PANEL */}
                    <Col lg={8} className="order-2 order-lg-1">
                        {loading ? (
                            <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                                <div className="spinner-border text-success mb-3" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <span className="font-mono text-success small letter-spacing-2">DECRYPTING INTELLIGENCE_</span>
                            </div>
                        ) : (selectedPost ? (
                            <div className="animate-fade-in">
                                <div className="reader-panel">
                                    {/* Intelligence Header */}
                                    <div className="border-bottom border-dark-3 pb-4 mb-4">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="badge-cyber">INTELLIGENCE FEED</span>
                                            {/* REPLACED REF_ID WITH DATE ONLY */}
                                            <span className="font-mono text-white small letter-spacing-2">
                                                {new Date(selectedPost.date).toLocaleDateString().toUpperCase()}
                                            </span>
                                        </div>
                                        <h1 className="blog-title">{selectedPost.title}</h1>
                                        <div className="d-flex align-items-center gap-4 mt-3 text-muted font-mono small">
                                            <span>
                                                <i className="bi bi-person-fill me-2 text-success"></i>
                                                QUANTUM_AI_O1
                                            </span>
                                        </div>
                                    </div>

                                    {/* Article Body */}
                                    <div className="blog-content">
                                        <div dangerouslySetInnerHTML={{ __html: selectedPost.content }} />

                                        {/* AUTOMATIC CTA FOOTER */}
                                        <div className="mt-5 pt-4 border-top border-dark-3" style={{ borderColor: '#333' }}>
                                            <p className="mb-2 font-mono" style={{ fontSize: '0.9rem' }}>
                                                <i className="bi bi-database-fill me-2" style={{ color: '#BC13FE' }}></i>
                                                <span style={{ color: '#aaa' }}>Bases de dados gratuitas {'->'} </span>
                                                <a href="https://t.me/bet_2all" target="_blank" rel="noreferrer" style={{ color: '#BC13FE', textDecoration: 'none' }}>
                                                    https://t.me/bet_2all
                                                </a>
                                            </p>
                                            <p className="mb-0 font-mono" style={{ fontSize: '0.9rem' }}>
                                                <i className="bi bi-tv-fill me-2" style={{ color: '#BC13FE' }}></i>
                                                <span style={{ color: '#aaa' }}>Onde assistir aos jogos {'->'} </span>
                                                <a href="https://wareztuga.io/" target="_blank" rel="noreferrer" style={{ color: '#BC13FE', textDecoration: 'none' }}>
                                                    https://wareztuga.io/
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="d-flex justify-content-center align-items-center text-muted border border-dark-3 p-5 rounded font-mono" style={{ minHeight: '400px', background: '#181818' }}>
                                AWAITING DATA SELECTION...
                            </div>
                        ))}
                    </Col>

                    {/* SIDEBAR ARCHIVE (30%) - DATA LOG */}
                    <Col lg={4} className="order-1 order-lg-2 mb-4 mb-lg-0">
                        <div className="sticky-top" style={{ top: '80px' }}>
                            <div className="d-flex align-items-center mb-3 pb-2 border-bottom border-dark-3">
                                <i className="bi bi-database me-2 text-success"></i>
                                <h5 className="font-header text-success mb-0">ARQUIVO / DATABASE</h5>
                            </div>

                            <div className="data-log-list custom-scrollbar">
                                {archive.map(post => (
                                    <div
                                        key={post.id}
                                        onClick={() => navigate(`/blog/${post.id}`)}
                                        className={`data-log-item ${selectedPost && selectedPost.id === post.id ? 'active' : ''}`}
                                    >
                                        <div className="d-flex justify-content-between mb-1">
                                            <small className="font-mono text-muted">{new Date(post.date).toLocaleDateString()}</small>
                                            {selectedPost && selectedPost.id === post.id && (
                                                <small className="font-mono text-success blink">A LER</small>
                                            )}
                                        </div>
                                        {/* Force white color for readability */}
                                        <h6 className="mb-0 font-inter" style={{ color: '#F0F0F0' }}>{post.match}</h6>
                                    </div>
                                ))}
                                {archive.length === 0 && <p className="font-mono text-muted small p-3">NO_RECORDS_FOUND</p>}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>

            <style>
                {`
                    /* ========== CYBERPUNK BLOG STYLES ========== */
                    :root {
                        --neon-purple: #BC13FE;
                    }

                    /* Typography Overrides */
                    .font-header { font-family: 'Orbitron', sans-serif; letter-spacing: 1px; }
                    .font-inter { font-family: 'Inter', sans-serif; }
                    .font-mono { font-family: 'JetBrains Mono', monospace; }
                    .letter-spacing-2 { letter-spacing: 2px; }
                    .border-dark-3 { border-color: #333 !important; }

                    /* Text Colors */
                    .text-neon-purple { color: var(--neon-purple) !important; }
                    .glow-purple { text-shadow: 0 0 10px rgba(188, 19, 254, 0.4); }

                    /* Reader Panel */
                    .reader-panel {
                        background: #181818;
                        border: 1px solid #333;
                        padding: 40px;
                        border-radius: 2px;
                        position: relative;
                        box-shadow: 0 0 20px rgba(0,0,0,0.5);
                    }
                    
                    /* Corner Accents for Reader Panel */
                    .reader-panel::before {
                        content: '';
                        position: absolute;
                        top: -1px; left: -1px;
                        width: 20px; height: 20px;
                        border-top: 2px solid var(--neon-green);
                        border-left: 2px solid var(--neon-green);
                    }
                    .reader-panel::after {
                        content: '';
                        position: absolute;
                        bottom: -1px; right: -1px;
                        width: 20px; height: 20px;
                        border-bottom: 2px solid var(--neon-green);
                        border-right: 2px solid var(--neon-green);
                    }

                    /* Badge Style */
                    .badge-cyber {
                        background: rgba(0, 255, 65, 0.1);
                        color: var(--neon-green);
                        border: 1px solid var(--neon-green);
                        padding: 4px 12px;
                        font-family: 'JetBrains Mono', monospace;
                        font-size: 0.7rem;
                        font-weight: bold;
                        letter-spacing: 1px;
                    }

                    /* Blog Title */
                    .blog-title {
                        font-family: 'Orbitron', sans-serif;
                        font-size: 2rem;
                        font-weight: 700;
                        color: #FFF;
                        margin-top: 1rem;
                        line-height: 1.2;
                        text-shadow: 0 0 10px rgba(0,0,0,0.5);
                    }

                    /* Blog Content */
                    .blog-content {
                        font-family: 'Inter', sans-serif;
                        color: #E0E0E0;
                        font-size: 1rem;
                        line-height: 1.7;
                    }
                    
                    .blog-content h1, .blog-content h2, .blog-content h3 { 
                        font-family: 'Orbitron', sans-serif;
                        color: var(--neon-green); 
                        margin-top: 2.5rem; 
                        margin-bottom: 1.5rem; 
                        text-transform: uppercase;
                        letter-spacing: 1px;
                    }
                    
                    .blog-content h2 { font-size: 1.5rem; border-left: 3px solid var(--neon-green); padding-left: 15px; }
                    .blog-content h3 { font-size: 1.25rem; }
                    
                    .blog-content p { margin-bottom: 1.5rem; color: #d0d0d0; }
                    .blog-content ul, .blog-content ol { margin-bottom: 1.5rem; padding-left: 2rem; }
                    .blog-content li { margin-bottom: 0.8rem; color: #ccc; marker: none;}
                    
                    /* SMART HIGHLIGHTING */
                    .blog-content strong, .blog-content b {
                        color: var(--neon-green) !important;
                        font-weight: 600;
                        background: rgba(0, 255, 65, 0.05);
                        padding: 0 2px;
                    }

                    /* Data Log (Sidebar) */
                    .data-log-list {
                        max-height: 80vh;
                        overflow-y: auto;
                        padding-right: 5px;
                    }
                    
                    .data-log-item {
                        background: #1E1E1E;
                        padding: 16px;
                        margin-bottom: 10px;
                        border-left: 3px solid transparent;
                        transition: all 0.2s ease;
                        cursor: pointer;
                        border-radius: 0 4px 4px 0;
                    }
                    
                    .data-log-item:hover {
                        background: #252528;
                        border-left-color: #555;
                        transform: translateX(5px);
                    }
                    
                    .data-log-item.active {
                        background: #222;
                        border-left-color: var(--neon-green);
                        box-shadow: inset 10px 0 20px -10px rgba(0, 255, 65, 0.1);
                    }
                    
                    /* Blink Animation */
                    .blink { animation: blinker 1.5s linear infinite; }
                    @keyframes blinker { 50% { opacity: 0; } }
                    
                    /* Custom Scrollbar for Sidebar */
                    .custom-scrollbar::-webkit-scrollbar { width: 4px; }
                    .custom-scrollbar::-webkit-scrollbar-track { background: #111; }
                    .custom-scrollbar::-webkit-scrollbar-thumb { background: #333; }
                    .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: var(--neon-green); }
                `}
            </style>
        </BaseLayout>
    );
};

export default Blog;
